import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import StakingTokenIcon from './StakingTokenIcon';

const RATE_KEYS = [
  { id: 'm03', labelKey: 'staking.rate_m03', pctKey: 'staking.rate_m03_pct' },
  { id: 'm36', labelKey: 'staking.rate_m36', pctKey: 'staking.rate_m36_pct' },
  { id: 'm69', labelKey: 'staking.rate_m69', pctKey: 'staking.rate_m69_pct' },
  { id: 'm912', labelKey: 'staking.rate_m912', pctKey: 'staking.rate_m912_pct' },
];

const UnStakesPanel = ({
  summary,
  items,
  tokenSymbol,
  onClaimAll,
  onCancelRequest,
  onClaimAvailable,
}) => {
  const { t } = useTranslation();
  const [helpOpen, setHelpOpen] = useState(false);

  return (
    <div className="staking-panel">
      <button
        type="button"
        className="staking-help-toggle staking-help-toggle--info"
        onClick={() => setHelpOpen((o) => !o)}
        aria-expanded={helpOpen}
      >
        <span className="staking-info-icon" aria-hidden>
          ⓘ
        </span>
        {t('staking.how_unstake_works', 'How does Un-Stake work?')}
        <span className="staking-help-chevron">{helpOpen ? '▲' : '▼'}</span>
      </button>
      {helpOpen ? (
        <div className="staking-help-body staking-help-body--card">
          <p className="staking-help-text">
            {t(
              'staking.unstake_help_body',
              'Your request will be processed once the current tranche is closed. At that point, your requested amount will be available for Un-Staking. If you choose to cancel, you will have the option to participate in the next tranche without incurring any charges.'
            )}
          </p>
          <h4 className="staking-rates-title">
            {t('staking.unstake_rates_title', 'Rates per anticipated retreat:')}
          </h4>
          <dl className="staking-rates-grid">
            {RATE_KEYS.map((row) => (
              <div key={row.id}>
                <dt>{t(row.labelKey)}</dt>
                <dd>{t(row.pctKey)}</dd>
              </div>
            ))}
          </dl>
        </div>
      ) : null}

      <section className="staking-available-box">
        <p className="staking-available-label">
          {t('staking.available_to_unstake', 'Available to Un-Stake')}
        </p>
        <p className="staking-available-value staking-available-value--row">
          <StakingTokenIcon symbol={tokenSymbol} />
          <span>
            {summary.availableToUnstake} {tokenSymbol}
          </span>
        </p>
      </section>

      <div className="staking-stats-row">
        <div className="staking-stat-card">
          <p className="staking-stat-label">{t('staking.requested', 'Requested')}</p>
          <p className="staking-stat-value">{summary.requested}</p>
        </div>
        <div className="staking-stat-card">
          <p className="staking-stat-label">{t('staking.total_claim', 'Total claim')}</p>
          <p className="staking-stat-value">{summary.totalClaim}</p>
        </div>
      </div>

      <button
        type="button"
        className="staking-btn staking-btn-secondary staking-btn-block"
        onClick={onClaimAll}
      >
        {t('staking.claim_all', 'Claim all')}
      </button>

      <section className="staking-section">
        <h3 className="staking-section-title sr-only">
          {t('staking.unstake_requests', 'Un-stake requests')}
        </h3>
        <ul className="staking-card-list staking-unstake-cards-grid">
          {items.map((row) => (
            <li
              key={row.id}
              className={`staking-unstake-card staking-unstake-card--${row.status}`}
            >
              <div className="staking-unstake-header">
                <span className="staking-unstake-amount">{row.amount}</span>
                <span className={`staking-status-badge staking-status-badge--${row.status}`}>
                  {t(`staking.status_${row.status}`, row.status)}
                </span>
              </div>
              <div className="staking-stake-meta">
                <span>
                  {t('staking.stake_date', 'Stake date')}: {row.stakeDate}
                </span>
                <span>
                  {t('staking.due_date', 'Due date')}: {row.dueDate}
                </span>
                {row.dueDateSecondary ? (
                  <span>
                    {t('staking.due_date_secondary', 'Due date')}: {row.dueDateSecondary}
                  </span>
                ) : null}
              </div>
              <div className="staking-unstake-fees">
                <span>
                  {t('staking.penalty_fee', 'Penalty fee')}: {row.penaltyFee}
                </span>
                <span>
                  {t('staking.drawdown_loss', 'Draw down loss')}: {row.drawDownLoss}
                </span>
              </div>
              <div className="staking-stake-actions">
                {row.status === 'requested' ? (
                  <button
                    type="button"
                    className="staking-btn staking-btn-warning"
                    onClick={() => onCancelRequest(row.id)}
                  >
                    {t('staking.cancel', 'Cancel')}
                  </button>
                ) : null}
                {row.status === 'available' ? (
                  <button
                    type="button"
                    className="staking-btn staking-btn-primary"
                    onClick={() => onClaimAvailable(row)}
                  >
                    {t('staking.claim', 'Claim')}
                  </button>
                ) : null}
                {row.status === 'claimed' ? (
                  <button type="button" className="staking-btn staking-btn-disabled" disabled>
                    {t('staking.claimed', 'Claimed')}
                  </button>
                ) : null}
              </div>
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
};

export default UnStakesPanel;
